import { useEffect, useState } from 'react';

const MOBILE_MAX_SHORT_SIDE_PX = 767;

export function detectIsMobileDevice(): boolean {
  const shortScreenSide = Math.min(window.screen.width, window.screen.height);
  const coarsePointer = window.matchMedia('(pointer: coarse)').matches;
  const hasTouchPoints = navigator.maxTouchPoints > 0;
  return shortScreenSide <= MOBILE_MAX_SHORT_SIDE_PX && (coarsePointer || hasTouchPoints);
}

export function useIsMobileDevice(): boolean {
  const [isMobileDevice, setIsMobileDevice] = useState(detectIsMobileDevice);

  useEffect(() => {
    const pointerQuery = window.matchMedia('(pointer: coarse)');
    const update = () => setIsMobileDevice(detectIsMobileDevice());

    update();
    pointerQuery.addEventListener('change', update);

    return () => {
      pointerQuery.removeEventListener('change', update);
    };
  }, []);

  return isMobileDevice;
}
